(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory;
  } else if (!root.VmaxWishlist || !root.VmaxWishlist._constants
    || root.VmaxWishlist._constants.adapterVersion !== '2.0.0') {
    root.VmaxWishlist = factory({ window: root });
  }
}(typeof window !== 'undefined' ? window : this, function createVmaxWishlist(options) {
  'use strict';

  options = options || {};

  var win = options.window || null;
  var strings = (win && win.theme && win.theme.strings && win.theme.strings.wishlist) || {};
  var routes = options.routes || (win && win.routes) || {};
  var doc = options.document || (win && win.document) || null;
  var eventTarget = options.eventTarget || win || null;
  var storage = Object.prototype.hasOwnProperty.call(options, 'storage')
    ? options.storage
    : getLocalStorage(win);
  var now = options.now || function () { return Date.now(); };
  var setTimer = options.setTimeout || (win && win.setTimeout ? win.setTimeout.bind(win) : setTimeout);
  var clearTimer = options.clearTimeout || (win && win.clearTimeout ? win.clearTimeout.bind(win) : clearTimeout);
  var cookie = options.cookie || createCookieAdapter(doc, now);
  var shopify = options.Shopify || (win && win.Shopify) || null;
  var request = options.request || createRequestAdapter(win);

  var COOKIE_NAME = 'wishlistList';
  var MIRROR_COOKIE_NAME = 'vmaxWishlistMirror';
  var STORAGE_KEY = 'vmaxWishlist.v1';
  var BACKUP_KEY = 'vmaxWishlist.backup.v1';
  var STORAGE_VERSION = 1;
  var COOKIE_DAYS = 400;
  var MAX_COOKIE_VALUE_LENGTH = 3600;
  var PRODUCT_TIMEOUT_MS = 8000;
  var MAX_CONCURRENT_PRODUCT_REQUESTS = 6;
  var ACCOUNT_CACHE_VERSION = 1;
  var ACCOUNT_OUTBOX_VERSION = 3;
  var ACCOUNT_LEGACY_OUTBOX_VERSION = 2;
  var ACCOUNT_PROXY_PATH = '/apps/vmax-deckbuilder/wishlist';
  var ACCOUNT_MUTATE_PATH = ACCOUNT_PROXY_PATH + '/mutate';
  var ACCOUNT_REQUEST_TIMEOUT_MS = 12000;
  var ACCOUNT_MAX_CONFLICT_RETRIES = 2;
  var ACCOUNT_ACK_RETENTION_LIMIT = 256;

  var initialized = false;
  var storageReadable = false;
  var storageAuthority = false;
  var legacyCookieReadable = false;
  var recoveryBlocked = false;
  var items = [];
  var currentUpdatedAt = 0;
  var pageRenderVersion = 0;
  var productRequestQueue = [];
  var activeProductRequests = 0;
  var accountMode = !!(shopify && shopify.customer_logged_in === true);
  var accountOpaqueKey = null;
  var accountScope = null;
  var accountScopeLoaded = false;
  var accountCacheKey = null;
  var accountOutboxKey = null;
  var accountOperationPrefix = null;
  var accountAcknowledgementPrefix = null;
  var accountImportKey = null;
  var accountSnapshot = null;
  var accountOutbox = [];
  var accountAcknowledgements = [];
  var accountOperationClock = 0;
  var accountOutboxPersistencePending = false;
  var accountHasSnapshot = false;
  var accountLoadedFromServer = false;
  var accountRefreshing = false;
  var accountMutationActive = false;
  var accountState = accountMode ? 'loading' : 'guest';
  var accountStorageBlocked = false;
  var accountRetryTimer = null;
  var accountRetryDelay = 2000;
  var guestItems = [];
  var guestRecoveryBlocked = false;
  var pendingMutationCallbacks = Object.create(null);

  function getLocalStorage(targetWindow) {
    if (!targetWindow) return null;

    try {
      return targetWindow.localStorage;
    } catch (error) {
      return null;
    }
  }

  function createRequestAdapter(targetWindow) {
    return function (method, path, body, callback) {
      var Xhr = targetWindow && targetWindow.XMLHttpRequest;
      if (!Xhr) {
        callback({ status: 0, data: null, networkError: true });
        return;
      }

      var xhr = new Xhr();
      var settled = false;

      function finish(networkError) {
        if (settled) return;
        settled = true;

        var data = null;
        if (xhr.responseText) {
          try {
            data = JSON.parse(xhr.responseText);
          } catch (error) {
            data = null;
          }
        }

        callback({
          status: Number(xhr.status) || 0,
          data: data,
          networkError: networkError === true
        });
      }

      try {
        xhr.open(method, path, true);
        xhr.timeout = ACCOUNT_REQUEST_TIMEOUT_MS;
        xhr.setRequestHeader('Accept', 'application/json');
        if (body !== null && typeof body !== 'undefined') {
          xhr.setRequestHeader('Content-Type', 'application/json');
        }
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) finish(false);
        };
        xhr.onerror = function () { finish(true); };
        xhr.ontimeout = function () { finish(true); };
        xhr.send(body === null || typeof body === 'undefined' ? null : JSON.stringify(body));
      } catch (error) {
        finish(true);
      }
    };
  }

  function activateAccountScope(accountKey) {
    if (typeof accountKey !== 'string' || !/^[a-zA-Z0-9_-]{16,160}$/.test(accountKey)) return false;
    if (accountOpaqueKey && accountOpaqueKey !== accountKey) {
      accountStorageBlocked = true;
      accountHasSnapshot = false;
      accountSnapshot = null;
      items = [];
      return false;
    }

    accountOpaqueKey = accountKey;
    accountScope = accountKey;
    accountCacheKey = 'vmaxWishlist.account.' + accountScope + '.v1';
    accountOutboxKey = 'vmaxWishlist.account.' + accountScope + '.outbox.v1';
    accountOperationPrefix = 'vmaxWishlist.account.' + accountScope + '.outbox.v3.operation.';
    accountAcknowledgementPrefix = 'vmaxWishlist.account.' + accountScope + '.outbox.v3.ack.';
    accountImportKey = 'vmaxWishlist.account.' + accountScope + '.import.v1';
    return true;
  }

  function createCookieAdapter(documentObject, currentTime) {
    return {
      get: function (name) {
        try {
          if (!documentObject || typeof documentObject.cookie !== 'string') return null;

          var encodedName = encodeURIComponent(name) + '=';
          var segments = documentObject.cookie ? documentObject.cookie.split(';') : [];

          for (var index = 0; index < segments.length; index += 1) {
            var segment = segments[index].trim();
            if (segment.indexOf(encodedName) === 0) {
              return decodeURIComponent(segment.slice(encodedName.length));
            }
          }
        } catch (error) {
          return null;
        }

        return null;
      },
      set: function (name, value, days) {
        if (!documentObject) return false;

        var expiry = new Date(currentTime() + (days * 24 * 60 * 60 * 1000)).toUTCString();
        var secure = documentObject.location && documentObject.location.protocol === 'https:' ? '; Secure' : '';
        documentObject.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)
          + '; expires=' + expiry + '; path=/; SameSite=Lax' + secure;

        return this.get(name) === value;
      },
      remove: function (name) {
        if (!documentObject) return false;

        documentObject.cookie = encodeURIComponent(name)
          + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';

        var value = this.get(name);
        return value === null || value === '';
      }
    };
  }

  function normalizeHandle(value) {
    if (typeof value !== 'string') return null;

    var handle = value.trim().toLowerCase();
    if (!handle || handle === 'undefined' || handle === 'null') return null;
    if (handle.length > 255 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return null;

    return handle;
  }

  function normalizeItems(values) {
    var result = [];
    var seen = Object.create(null);

    if (!Array.isArray(values)) return result;

    values.forEach(function (value) {
      var handle = normalizeHandle(value);
      if (handle && !seen[handle]) {
        seen[handle] = true;
        result.push(handle);
      }
    });

    return result;
  }

  function parseLegacyCookie(value) {
    if (typeof value !== 'string' || !value || value === '__') return [];
    return normalizeItems(value.split('__'));
  }

  function serializeLegacyCookie(values) {
    return normalizeItems(values).join('__');
  }

  function fingerprint(value) {
    var text = typeof value === 'string' ? value : '';
    var hash = 5381;

    for (var index = 0; index < text.length; index += 1) {
      hash = ((hash * 33) ^ text.charCodeAt(index)) >>> 0;
    }

    return hash.toString(36) + ':' + String(text.length);
  }

  function sameItems(left, right) {
    if (left.length !== right.length) return false;

    for (var index = 0; index < left.length; index += 1) {
      if (left[index] !== right[index]) return false;
    }

    return true;
  }

  function normalizeRevision(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    if (typeof value === 'string' && value.length <= 128) return value;
    return null;
  }

  function normalizeServerWishlist(value) {
    if (!value || value.version !== 1 || !Array.isArray(value.items)) return null;

    var revision = normalizeRevision(value.revision);
    if (revision === null) return null;

    var normalizedItems = [];
    var seen = Object.create(null);
    for (var index = 0; index < value.items.length; index += 1) {
      var rawItem = value.items[index];
      var handle = normalizeHandle(rawItem && rawItem.handle);
      if (!handle || seen[handle]) return null;
      seen[handle] = true;
      normalizedItems.push({
        handle: handle,
        addedAt: rawItem && (typeof rawItem.addedAt === 'string' || typeof rawItem.addedAt === 'number')
          ? rawItem.addedAt
          : null
      });
    }

    return {
      version: 1,
      revision: revision,
      items: normalizedItems,
      updatedAt: typeof value.updatedAt === 'string' || typeof value.updatedAt === 'number'
        ? value.updatedAt
        : null
    };
  }

  function parseAccountEnvelope(value) {
    if (!value || value.ok !== true || value.authenticated !== true) return null;
    if (typeof value.accountKey !== 'string' || !/^[a-zA-Z0-9_-]{16,160}$/.test(value.accountKey)) return null;
    var wishlist = normalizeServerWishlist(value.wishlist);
    if (!wishlist) return null;

    return {
      accountKey: value.accountKey,
      wishlist: wishlist,
      etag: typeof value.etag === 'string' && value.etag.length <= 256 ? value.etag : null
    };
  }

  function snapshotHandles(snapshot) {
    if (!snapshot || !Array.isArray(snapshot.items)) return [];
    return snapshot.items.map(function (item) { return item.handle; });
  }

  function readAccountValue(key, parser) {
    if (!storage || !key) return { status: 'unavailable', value: null };

    try {
      var rawValue = storage.getItem(key);
      if (rawValue === null) return { status: 'absent', value: null };
      var parsed = JSON.parse(rawValue);
      var value = parser(parsed);
      return value
        ? { status: 'valid', value: value }
        : { status: 'invalid', value: null };
    } catch (error) {
      return { status: 'unavailable', value: null };
    }
  }

  function writeAccountValueResult(key, value) {
    if (!storage || !key) return { ok: false, error: null };

    try {
      var rawValue = JSON.stringify(value);
      if (storage.getItem(key) === rawValue) return { ok: true, error: null };
      storage.setItem(key, rawValue);
      return {
        ok: storage.getItem(key) === rawValue,
        error: null
      };
    } catch (error) {
      return { ok: false, error: error };
    }
  }

  function writeAccountValue(key, value) {
    return writeAccountValueResult(key, value).ok;
  }

  function isStorageQuotaError(error) {
    if (!error) return false;
    return error.name === 'QuotaExceededError'
      || error.name === 'NS_ERROR_DOM_QUOTA_REACHED'
      || error.code === 22
      || error.code === 1014
      || /quota/i.test(String(error.message || ''));
  }

  function parseAccountCache(value) {
    if (!value || value.version !== ACCOUNT_CACHE_VERSION) return null;
    var wishlist = normalizeServerWishlist(value.wishlist);
    if (!wishlist) return null;

    return {
      version: ACCOUNT_CACHE_VERSION,
      wishlist: wishlist,
      etag: typeof value.etag === 'string' && value.etag.length <= 256 ? value.etag : null
    };
  }

  function normalizeOperation(value, legacyExpectedAccountKey) {
    if (!value || typeof value.requestId !== 'string'
      || !/^[a-zA-Z0-9-]{16,80}$/.test(value.requestId)) return null;
    if (['add', 'remove', 'merge'].indexOf(value.operation) === -1) return null;

    var expectedAccountKey = typeof value.expectedAccountKey === 'string'
      ? value.expectedAccountKey
      : legacyExpectedAccountKey;
    if (typeof expectedAccountKey !== 'string'
      || !/^[a-zA-Z0-9_-]{16,160}$/.test(expectedAccountKey)) return null;

    var operation = {
      requestId: value.requestId,
      expectedAccountKey: expectedAccountKey,
      operation: value.operation,
      baseRevision: value.baseRevision === null || typeof value.baseRevision === 'undefined'
        ? null
        : normalizeRevision(value.baseRevision),
      sent: value.sent === true,
      conflictRetries: typeof value.conflictRetries === 'number'
        && isFinite(value.conflictRetries)
        && Math.floor(value.conflictRetries) === value.conflictRetries
        && value.conflictRetries >= 0
        ? value.conflictRetries
        : 0,
      order: typeof value.order === 'number'
        && isFinite(value.order)
        && Math.floor(value.order) === value.order
        && value.order >= 0
        ? value.order
        : 0,
      blocked: value.blocked === true,
      createdAt: typeof value.createdAt === 'number' ? value.createdAt : 0,
      importFingerprint: typeof value.importFingerprint === 'string' ? value.importFingerprint : null
    };

    if (operation.baseRevision === null && value.baseRevision !== null
      && typeof value.baseRevision !== 'undefined') return null;

    if (operation.operation === 'add' || operation.operation === 'remove') {
      operation.handle = normalizeHandle(value.handle);
      if (!operation.handle) return null;
    } else {
      operation.handles = normalizeItems(value.handles);
      if (!Array.isArray(value.handles) || operation.handles.length !== value.handles.length) return null;
    }

    return operation;
  }

  function normalizeAcknowledgement(value) {
    if (!value || typeof value.requestId !== 'string'
      || !/^[a-zA-Z0-9-]{16,80}$/.test(value.requestId)) return null;
    return {
      requestId: value.requestId,
      acknowledgedAt: typeof value.acknowledgedAt === 'number' && isFinite(value.acknowledgedAt)
        ? value.acknowledgedAt
        : 0
    };
  }

  function parseLegacyAccountOutbox(value) {
    if (!value || (value.version !== 1 && value.version !== ACCOUNT_LEGACY_OUTBOX_VERSION)
      || !Array.isArray(value.operations)) return null;

    var operations = [];
    var legacyOrder = 0;
    for (var index = 0; index < value.operations.length; index += 1) {
      var operation = normalizeOperation(value.operations[index], accountOpaqueKey);
      if (!operation || operation.expectedAccountKey !== accountOpaqueKey) return null;
      operation.order = Math.max(
        operation.order,
        typeof operation.createdAt === 'number' ? Math.floor(operation.createdAt) : 0,
        legacyOrder + 1
      );
      legacyOrder = operation.order;
      operations.push(operation);
    }

    var acknowledgements = [];
    if (value.version === ACCOUNT_LEGACY_OUTBOX_VERSION) {
      if (!Array.isArray(value.acknowledgements)) return null;
      for (var acknowledgementIndex = 0;
        acknowledgementIndex < value.acknowledgements.length;
        acknowledgementIndex += 1) {
        var acknowledgement = normalizeAcknowledgement(value.acknowledgements[acknowledgementIndex]);
        if (!acknowledgement) return null;
        acknowledgements.push(acknowledgement);
      }
    }

    return {
      version: ACCOUNT_OUTBOX_VERSION,
      operations: operations,
      acknowledgements: acknowledgements
    };
  }

  function saveAccountSnapshot() {
    if (!accountSnapshot || !accountCacheKey) return false;
    return writeAccountValue(accountCacheKey, {
      version: ACCOUNT_CACHE_VERSION,
      wishlist: accountSnapshot,
      etag: accountSnapshot.etag || null
    });
  }

  function operationCoreSignature(operation) {
    return JSON.stringify({
      expectedAccountKey: operation.expectedAccountKey,
      order: operation.order,
      operation: operation.operation,
      handle: operation.handle || null,
      handles: operation.handles || null,
      importFingerprint: operation.importFingerprint || null
    });
  }

  function operationRequestSignature(operation) {
    return JSON.stringify({
      requestId: operation.requestId,
      expectedAccountKey: operation.expectedAccountKey,
      operation: operation.operation,
      handle: operation.handle || null,
      handles: operation.handles || null,
      baseRevision: operation.baseRevision
    });
  }

  function mergeAccountOutboxStates(firstState, secondState) {
    var acknowledgementMap = Object.create(null);
    var acknowledgements = [];

    function addAcknowledgement(value) {
      var acknowledgement = normalizeAcknowledgement(value);
      if (!acknowledgement) return false;
      var existing = acknowledgementMap[acknowledgement.requestId];
      if (!existing) {
        acknowledgementMap[acknowledgement.requestId] = acknowledgement;
        acknowledgements.push(acknowledgement);
      } else if (acknowledgement.acknowledgedAt > existing.acknowledgedAt) {
        existing.acknowledgedAt = acknowledgement.acknowledgedAt;
      }
      return true;
    }

    (firstState.acknowledgements || []).forEach(addAcknowledgement);
    (secondState.acknowledgements || []).forEach(addAcknowledgement);
    acknowledgements.sort(function (left, right) {
      return left.acknowledgedAt - right.acknowledgedAt;
    });

    var operations = [];
    var operationMap = Object.create(null);
    var invalid = false;

    function addOperation(value) {
      if (invalid) return;
      var operation = normalizeOperation(value);
      if (!operation) {
        invalid = true;
        return;
      }
      if (acknowledgementMap[operation.requestId]) return;

      var existing = operationMap[operation.requestId];
      if (!existing) {
        operationMap[operation.requestId] = operation;
        operations.push(operation);
        return;
      }
      if (operationCoreSignature(existing) !== operationCoreSignature(operation)) {
        invalid = true;
        return;
      }
      if (existing.sent && operation.sent
        && operationRequestSignature(existing) !== operationRequestSignature(operation)) {
        invalid = true;
        return;
      }
      if (!existing.sent && operation.sent) {
        var existingIndex = operations.indexOf(existing);
        operations[existingIndex] = operation;
        operationMap[operation.requestId] = operation;
        existing = operation;
      }
      existing.conflictRetries = Math.max(existing.conflictRetries, operation.conflictRetries);
    }

    (firstState.operations || []).forEach(addOperation);
    (secondState.operations || []).forEach(addOperation);
    if (invalid) return null;

    operations.sort(function (left, right) {
      if (left.order !== right.order) return left.order - right.order;
      if (left.requestId < right.requestId) return -1;
      if (left.requestId > right.requestId) return 1;
      return 0;
    });
    operations.forEach(function (operation) {
      accountOperationClock = Math.max(accountOperationClock, operation.order);
    });

    return { operations: operations, acknowledgements: acknowledgements };
  }

  function parseJournalOperation(value, requestId) {
    if (!value || value.version !== ACCOUNT_OUTBOX_VERSION) return null;
    var operation = normalizeOperation(value.operation);
    if (!operation || operation.requestId !== requestId
      || operation.expectedAccountKey !== accountOpaqueKey
      || operation.order <= 0) return null;
    return operation;
  }

  function parseJournalAcknowledgement(value, requestId) {
    if (!value || value.version !== ACCOUNT_OUTBOX_VERSION) return null;
    var acknowledgement = normalizeAcknowledgement(value.acknowledgement || {
      requestId: requestId,
      acknowledgedAt: value.acknowledgedAt
    });
    return acknowledgement && acknowledgement.requestId === requestId ? acknowledgement : null;
  }

  function nextAccountOperationOrder(wallTime) {
    var wallClock = typeof wallTime === 'number' && isFinite(wallTime)
      ? Math.max(0, Math.floor(wallTime))
      : 0;
    var observedClock = accountOperationClock;
    accountOutbox.forEach(function (operation) {
      observedClock = Math.max(observedClock, operation.order || 0);
    });
    accountOperationClock = Math.max(wallClock, accountOperationClock + 1, observedClock + 1);
    return accountOperationClock;
  }

  function listAccountJournalKeys() {
    if (!storage || typeof storage.key !== 'function') {
      return { status: 'unavailable', keys: [] };
    }

    try {
      var keys = [];
      var storageLength = storage.length;
      if (typeof storageLength !== 'number') return { status: 'unavailable', keys: [] };
      for (var index = 0; index < storageLength; index += 1) {
        var key = storage.key(index);
        if (typeof key === 'string'
          && (key.indexOf(accountOperationPrefix) === 0
            || key.indexOf(accountAcknowledgementPrefix) === 0)) keys.push(key);
      }
      return { status: 'valid', keys: keys };
    } catch (error) {
      return { status: 'unavailable', keys: [] };
    }
  }

  function readAccountJournalState() {
    var listed = listAccountJournalKeys();
    if (listed.status !== 'valid') return { status: listed.status, value: null };

    var state = { operations: [], acknowledgements: [] };
    for (var index = 0; index < listed.keys.length; index += 1) {
      var key = listed.keys[index];
      var isOperation = key.indexOf(accountOperationPrefix) === 0;
      var prefix = isOperation ? accountOperationPrefix : accountAcknowledgementPrefix;
      var requestId = key.slice(prefix.length);
      if (!/^[a-zA-Z0-9-]{16,80}$/.test(requestId)) {
        return { status: 'invalid', value: null };
      }
      var entry = readAccountValue(key, isOperation
        ? function (value) { return parseJournalOperation(value, requestId); }
        : function (value) { return parseJournalAcknowledgement(value, requestId); });
      // Another tab may acknowledge and remove an operation during enumeration.
      if (entry.status === 'absent') continue;
      if (entry.status !== 'valid') return { status: entry.status, value: null };
      if (isOperation) state.operations.push(entry.value);
      else state.acknowledgements.push(entry.value);
    }

    var normalized = mergeAccountOutboxStates(
      { operations: [], acknowledgements: [] },
      state
    );
    return normalized
      ? { status: 'valid', value: normalized }
      : { status: 'invalid', value: null };
  }

  function readPersistedAccountOutbox() {
    var journal = readAccountJournalState();
    if (journal.status !== 'valid') return journal;

    var legacy = readAccountValue(accountOutboxKey, parseLegacyAccountOutbox);
    if (legacy.status === 'invalid' || legacy.status === 'unavailable') return legacy;
    var merged = mergeAccountOutboxStates(
      journal.value,
      legacy.status === 'valid'
        ? legacy.value
        : { operations: [], acknowledgements: [] }
    );
    return merged
      ? { status: 'valid', value: merged, legacyPresent: legacy.status === 'valid' }
      : { status: 'invalid', value: null };
  }

  function accountOperationKey(requestId) {
    return accountOperationPrefix + requestId;
  }

  function accountAcknowledgementKey(requestId) {
    return accountAcknowledgementPrefix + requestId;
  }

  function removeAccountValue(key) {
    if (!storage || !key) return false;
    try {
      storage.removeItem(key);
      return storage.getItem(key) === null;
    } catch (error) {
      return false;
    }
  }

  function legacyAccountOutboxExists() {
    if (!storage || !accountOutboxKey) return true;
    try {
      return storage.getItem(accountOutboxKey) !== null;
    } catch (error) {
      return true;
    }
  }

  function garbageCollectAccountAcknowledgements(maxRetained, protectedRequestId) {
    if (!storage || !accountAcknowledgementPrefix || legacyAccountOutboxExists()) return false;
    var listed = listAccountJournalKeys();
    if (listed.status !== 'valid') return false;

    var acknowledgementMap = Object.create(null);
    var acknowledgements = [];
    function includeAcknowledgement(value) {
      var acknowledgement = normalizeAcknowledgement(value);
      if (!acknowledgement) return false;
      var existing = acknowledgementMap[acknowledgement.requestId];
      if (!existing) {
        acknowledgementMap[acknowledgement.requestId] = acknowledgement;
        acknowledgements.push(acknowledgement);
      } else if (acknowledgement.acknowledgedAt > existing.acknowledgedAt) {
        existing.acknowledgedAt = acknowledgement.acknowledgedAt;
      }
      return true;
    }

    accountAcknowledgements.forEach(includeAcknowledgement);
    for (var index = 0; index < listed.keys.length; index += 1) {
      var key = listed.keys[index];
      if (key.indexOf(accountAcknowledgementPrefix) !== 0) continue;
      var requestId = key.slice(accountAcknowledgementPrefix.length);
      var entry = readAccountValue(
        key,
        function (value) { return parseJournalAcknowledgement(value, requestId); }
      );
      if (entry.status !== 'valid' || !includeAcknowledgement(entry.value)) return false;
    }

    acknowledgements.sort(function (left, right) {
      if (left.acknowledgedAt !== right.acknowledgedAt) {
        return left.acknowledgedAt - right.acknowledgedAt;
      }
      if (left.requestId < right.requestId) return -1;
      if (left.requestId > right.requestId) return 1;
      return 0;
    });

    var retentionLimit = typeof maxRetained === 'number'
      ? Math.max(0, Math.floor(maxRetained))
      : ACCOUNT_ACK_RETENTION_LIMIT;
    var retainedMap = Object.create(null);
    var protectedExists = typeof protectedRequestId === 'string'
      && acknowledgementMap[protectedRequestId];
    var remainingSlots = Math.max(0, retentionLimit - (protectedExists ? 1 : 0));
    if (protectedExists) retainedMap[protectedRequestId] = true;
    for (var retainIndex = acknowledgements.length - 1;
      retainIndex >= 0 && remainingSlots > 0;
      retainIndex -= 1) {
      var retained = acknowledgements[retainIndex];
      if (retained.requestId === protectedRequestId) continue;
      retainedMap[retained.requestId] = true;
      remainingSlots -= 1;
    }

    for (var removeIndex = 0; removeIndex < acknowledgements.length; removeIndex += 1) {
      var candidate = acknowledgements[removeIndex];
      if (retainedMap[candidate.requestId]) continue;
      var operation = readAccountValue(
        accountOperationKey(candidate.requestId),
        function (value) { return parseJournalOperation(value, candidate.requestId); }
      );
      // Never remove a tombstone while its exact operation is present or its
      // state cannot be inspected. A later pass can collect it safely.
      if (operation.status !== 'absent') {
        retainedMap[candidate.requestId] = true;
        continue;
      }
      if (!removeAccountValue(accountAcknowledgementKey(candidate.requestId))) {
        retainedMap[candidate.requestId] = true;
      }
    }

    accountAcknowledgements = acknowledgements.filter(function (acknowledgement) {
      return retainedMap[acknowledgement.requestId] === true;
    });
    return true;
  }

  function retryWriteAfterAcknowledgementGc(writeEntry) {
    // localStorage quotas vary (and can be much smaller in private modes).
    // A write is accepted only after a retry is durably verified. Only an
    // explicit quota error enters this path; any other ACK failure still
    // blocks replay until the normal GET reconciliation.
    var emergencyLimits = [128, 64, 32, 16, 0];
    for (var index = 0; index < emergencyLimits.length; index += 1) {
      if (!garbageCollectAccountAcknowledgements(emergencyLimits[index])) continue;
      var result = writeEntry();
      if (result.ok) return true;
      if (!isStorageQuotaError(result.error)) return false;
    }
    return false;
  }

  function persistAccountOperation(operation, skipGarbageCollection) {
    if (!operation || operation.expectedAccountKey !== accountOpaqueKey) return false;
    if (!skipGarbageCollection) garbageCollectAccountAcknowledgements();
    var acknowledgement = readAccountValue(
      accountAcknowledgementKey(operation.requestId),
      function (value) { return parseJournalAcknowledgement(value, operation.requestId); }
    );
    if (acknowledgement.status === 'valid') return true;
    if (acknowledgement.status === 'invalid' || acknowledgement.status === 'unavailable') return false;

    var key = accountOperationKey(operation.requestId);
    var existing = readAccountValue(
      key,
      function (value) { return parseJournalOperation(value, operation.requestId); }
    );
    if (existing.status === 'invalid' || existing.status === 'unavailable') return false;
    var merged = mergeAccountOutboxStates(
      existing.status === 'valid'
        ? { operations: [existing.value], acknowledgements: [] }
        : { operations: [], acknowledgements: [] },
      { operations: [operation], acknowledgements: [] }
    );
    if (!merged || merged.operations.length !== 1) return false;
    function writeOperation() {
      return writeAccountValueResult(key, {
        version: ACCOUNT_OUTBOX_VERSION,
        operation: merged.operations[0]
      });
    }
    var operationWrite = writeOperation();
    return operationWrite.ok || (isStorageQuotaError(operationWrite.error)
      && retryWriteAfterAcknowledgementGc(writeOperation));
  }

  function persistAccountAcknowledgement(acknowledgement, skipGarbageCollection) {
    var normalized = normalizeAcknowledgement(acknowledgement);
    if (!normalized) return false;
    if (!skipGarbageCollection) garbageCollectAccountAcknowledgements(
      ACCOUNT_ACK_RETENTION_LIMIT - 1
    );
    function writeAcknowledgement() {
      return writeAccountValueResult(accountAcknowledgementKey(normalized.requestId), {
        version: ACCOUNT_OUTBOX_VERSION,
        acknowledgedAt: normalized.acknowledgedAt
      });
    }
    var acknowledgementWrite = writeAcknowledgement();
    var saved = acknowledgementWrite.ok || (isStorageQuotaError(acknowledgementWrite.error)
      && retryWriteAfterAcknowledgementGc(writeAcknowledgement));
    if (!saved) return false;
    return removeAccountValue(accountOperationKey(normalized.requestId));
  }

  function removeLegacyAccountOutbox() {
    if (!storage || !accountOutboxKey) return false;
    return removeAccountValue(accountOutboxKey);
  }

  function saveAccountOutbox(options) {
    if (!accountOutboxKey || !accountOperationPrefix || !accountAcknowledgementPrefix) return false;
    options = options || {};
    if (options.acknowledgeRequestId) {
      accountAcknowledgements.push({
        requestId: options.acknowledgeRequestId,
        acknowledgedAt: now()
      });
    }

    garbageCollectAccountAcknowledgements(
      ACCOUNT_ACK_RETENTION_LIMIT,
      options.acknowledgeRequestId || null
    );

    for (var acknowledgementIndex = 0;
      acknowledgementIndex < accountAcknowledgements.length;
      acknowledgementIndex += 1) {
      if (!persistAccountAcknowledgement(
        accountAcknowledgements[acknowledgementIndex],
        true
      )) return false;
    }
    for (var operationIndex = 0; operationIndex < accountOutbox.length; operationIndex += 1) {
      if (!persistAccountOperation(accountOutbox[operationIndex], true)) return false;
    }

    var persisted = readPersistedAccountOutbox();
    if (persisted.status !== 'valid') {
      if (persisted.status === 'invalid') accountStorageBlocked = true;
      return false;
    }
    var merged = mergeAccountOutboxStates(persisted.value, {
      operations: accountOutbox,
      acknowledgements: accountAcknowledgements
    });
    if (!merged) return false;
    accountOutbox = merged.operations;
    accountAcknowledgements = merged.acknowledgements;
    if (persisted.legacyPresent) {
      // The legacy record may have appeared only during the final read after a
      // transient storage failure. Persist every newly discovered entry before
      // removing that migration source.
      for (var migratedAcknowledgementIndex = 0;
        migratedAcknowledgementIndex < accountAcknowledgements.length;
        migratedAcknowledgementIndex += 1) {
        if (!persistAccountAcknowledgement(
          accountAcknowledgements[migratedAcknowledgementIndex],
          true
        )) return false;
      }
      for (var migratedOperationIndex = 0;
        migratedOperationIndex < accountOutbox.length;
        migratedOperationIndex += 1) {
        if (!persistAccountOperation(accountOutbox[migratedOperationIndex], true)) return false;
      }
      removeLegacyAccountOutbox();
    }
    return true;
  }

  function removeAccountOperationLocally(requestId) {
    accountOutbox = accountOutbox.filter(function (operation) {
      return operation.requestId !== requestId;
    });
    accountAcknowledgements.push({ requestId: requestId, acknowledgedAt: now() });
  }

  function applyAccountOperation(values, operation) {
    var result = values.slice();
    if (operation.operation === 'add') {
      if (result.indexOf(operation.handle) === -1) result.push(operation.handle);
    } else if (operation.operation === 'remove') {
      result = result.filter(function (handle) { return handle !== operation.handle; });
    } else if (operation.operation === 'merge') {
      operation.handles.forEach(function (handle) {
        if (result.indexOf(handle) === -1) result.push(handle);
      });
    }
    return result;
  }

  function projectAccountItems() {
    if (!accountHasSnapshot || !accountSnapshot) {
      items = [];
      return items;
    }

    var projected = snapshotHandles(accountSnapshot);
    accountOutbox.forEach(function (operation) {
      // A browser-only list becomes part of the account only after the server
      // acknowledges the explicit merge. Normal add/remove actions remain
      // optimistic because their durable requestId can be replayed safely.
      if (operation.operation !== 'merge') projected = applyAccountOperation(projected, operation);
    });
    items = normalizeItems(projected);
    return items;
  }

  function mergeLoadedAccountOutbox(value, persistMerged) {
    var merged = mergeAccountOutboxStates(
      value,
      { operations: accountOutbox, acknowledgements: accountAcknowledgements }
    );
    if (!merged) {
      accountStorageBlocked = true;
      accountState = 'unavailable';
      return false;
    }

    accountOutbox = merged.operations;
    accountAcknowledgements = merged.acknowledgements;
    if (persistMerged && !saveAccountOutbox()) {
      accountOutboxPersistencePending = true;
      accountState = 'stale';
      scheduleAccountRetry();
    }
    return true;
  }

  function loadAccountState() {
    var cache = readAccountValue(accountCacheKey, parseAccountCache);
    if (cache.status === 'valid') {
      accountSnapshot = cache.value.wishlist;
      accountSnapshot.etag = cache.value.etag;
      accountHasSnapshot = true;
      accountState = 'stale';
    } else if (cache.status === 'invalid') {
      accountStorageBlocked = true;
      accountState = 'unavailable';
    }

    var outbox = readPersistedAccountOutbox();
    if (outbox.status === 'valid') {
      mergeLoadedAccountOutbox(outbox.value, true);
    } else if (outbox.status === 'invalid') {
      accountStorageBlocked = true;
      accountState = 'unavailable';
    } else if (outbox.status === 'unavailable') {
      accountOutboxPersistencePending = true;
      accountState = 'stale';
      scheduleAccountRetry();
    }

    projectAccountItems();
  }

  function loadAccountOutboxForScope() {
    if (accountScopeLoaded || !accountOutboxKey) return;
    accountScopeLoaded = true;

    var outbox = readPersistedAccountOutbox();
    if (outbox.status === 'valid') {
      mergeLoadedAccountOutbox(outbox.value, true);
    } else if (outbox.status === 'invalid') {
      accountStorageBlocked = true;
      accountState = 'unavailable';
    } else if (outbox.status === 'unavailable') {
      accountOutboxPersistencePending = true;
      accountState = 'stale';
      scheduleAccountRetry();
    }
  }

  function createRequestId() {
    if (win && win.crypto && typeof win.crypto.randomUUID === 'function') {
      return win.crypto.randomUUID();
    }

    var randomPart = '';
    if (win && win.crypto && typeof win.crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(16);
      win.crypto.getRandomValues(bytes);
      for (var byteIndex = 0; byteIndex < bytes.length; byteIndex += 1) {
        randomPart += ('0' + bytes[byteIndex].toString(16)).slice(-2);
      }
    } else {
      for (var index = 0; index < 32; index += 1) {
        randomPart += Math.floor(Math.random() * 16).toString(16);
      }
    }
    return randomPart.slice(0, 8) + '-' + randomPart.slice(8, 12) + '-4'
      + randomPart.slice(13, 16) + '-a' + randomPart.slice(17, 20) + '-'
      + randomPart.slice(20, 32);
  }

  function operationBody(operation) {
    if (!operation || operation.expectedAccountKey !== accountOpaqueKey) return null;
    var body = {
      requestId: operation.requestId,
      operation: operation.operation,
      expectedAccountKey: operation.expectedAccountKey
    };
    if (operation.baseRevision !== null) body.baseRevision = operation.baseRevision;
    if (operation.handle) body.handle = operation.handle;
    if (operation.handles) body.handles = operation.handles.slice();
    return body;
  }

  function getGuestFingerprint() {
    return fingerprint(serializeLegacyCookie(guestItems));
  }

  function wasGuestListImported() {
    if (!storage || !accountImportKey || !guestItems.length) return false;
    try {
      return storage.getItem(accountImportKey) === getGuestFingerprint();
    } catch (error) {
      return false;
    }
  }

  function rememberGuestImport(importFingerprint) {
    if (!storage || !accountImportKey || !importFingerprint) return false;
    try {
      storage.setItem(accountImportKey, importFingerprint);
      return storage.getItem(accountImportKey) === importFingerprint;
    } catch (error) {
      return false;
    }
  }

  function readAuthoritativeGuestItemsForImport() {
    var primary = readStorage(STORAGE_KEY);
    if (primary.status === 'valid') {
      var primaryCookieCandidate = readCookieRecoveryCandidate(
        primary.payload.updatedAt,
        primary.payload.items
      );
      return primaryCookieCandidate
        ? primaryCookieCandidate.items.slice()
        : primary.payload.items.slice();
    }

    if (primary.status === 'invalid' || primary.status === 'absent') {
      var backup = readStorage(BACKUP_KEY);
      if (backup.status === 'valid') {
        var backupCookieCandidate = readCookieRecoveryCandidate(
          backup.payload.updatedAt,
          backup.payload.items
        );
        return backupCookieCandidate
          ? backupCookieCandidate.items.slice()
          : backup.payload.items.slice();
      }
      if (backup.status === 'invalid') return null;
    }

    if (primary.status === 'unavailable') return readValidCookieItems();
    return null;
  }

  function clearGuestAfterImport(importFingerprint) {
    var currentGuestItems = readAuthoritativeGuestItemsForImport();
    if (currentGuestItems) {
      guestItems = currentGuestItems.slice();
      if (fingerprint(serializeLegacyCookie(currentGuestItems)) === importFingerprint) {
        rememberGuestImport(importFingerprint);
      }
    }
    // An import is a server-side union, never authorization to delete the
    // browser-only source. Keeping it removes the unavoidable read/write race
    // with another tab adding an item while the merge ACK is processed.
    return false;
  }

  function updateAccountPresentation(source) {
    projectAccountItems();
    syncButtons();
    renderWishlistPage();
    emitChange(source);
  }

  function recordAccountRequestDiagnostic(response, envelope) {
    if (!doc || typeof doc.getElementById !== 'function') return;
    var marker = doc.getElementById('wishlist-js');
    if (!marker || typeof marker.setAttribute !== 'function') return;

    var status = response ? Number(response.status) || 0 : 0;
    var result = envelope ? 'OK' : 'INVALID_RESPONSE';
    var errorCode = responseErrorCode(response);
    if (status === 0) result = 'NETWORK_ERROR';
    else if (errorCode && /^[A-Z][A-Z0-9_]{0,63}$/.test(errorCode)) result = errorCode;

    marker.setAttribute('data-vmax-wishlist-last-request-status', String(status));
    marker.setAttribute('data-vmax-wishlist-last-request-result', result);
  }

  function scheduleAccountRetry() {
    if (!accountMode || accountRetryTimer || accountStorageBlocked) return;
    accountRetryTimer = setTimer(function () {
      accountRetryTimer = null;
      refreshAccount();
    }, accountRetryDelay);
    accountRetryDelay = Math.min(accountRetryDelay * 2, 60000);
  }

  function refreshAccount(callback) {
    if (!accountMode || accountRefreshing) return;
    accountRefreshing = true;

    request('GET', ACCOUNT_PROXY_PATH, null, function (response) {
      accountRefreshing = false;
      var envelope = response && response.status >= 200 && response.status < 300
        ? parseAccountEnvelope(response.data)
        : null;
      recordAccountRequestDiagnostic(response, envelope);

      if (envelope && activateAccountScope(envelope.accountKey)) {
        loadAccountOutboxForScope();
        accountSnapshot = envelope.wishlist;
        accountSnapshot.etag = envelope.etag;
        accountHasSnapshot = true;
        accountLoadedFromServer = true;
        accountState = accountStorageBlocked ? 'unavailable' : 'ready';
        accountRetryDelay = 2000;
        saveAccountSnapshot();
        if (accountOutboxPersistencePending) {
          if (!saveAccountOutbox()) {
            accountState = 'stale';
            updateAccountPresentation('outbox-reconcile-error');
            if (typeof callback === 'function') callback(false);
            scheduleAccountRetry();
            return;
          }
          accountOutboxPersistencePending = false;
        }
        updateAccountPresentation('server');
        if (typeof callback === 'function') callback(true);
        flushAccountOutbox();
        return;
      }

      var refreshErrorCode = responseErrorCode(response);
      if (response && response.status === 410
        && (refreshErrorCode === 'ACCOUNT_REDACTED' || refreshErrorCode === 'SHOP_REDACTED')) {
        accountLoadedFromServer = false;
        accountStorageBlocked = true;
        accountHasSnapshot = false;
        accountSnapshot = null;
        items = [];
        accountState = 'unavailable';
        updateAccountPresentation('account-redacted');
        if (typeof callback === 'function') callback(false);
        return;
      }

      accountLoadedFromServer = false;
      accountState = response && (response.status === 401 || response.status === 403)
        ? 'auth'
        : (accountHasSnapshot ? 'stale' : 'unavailable');
      updateAccountPresentation('server-error');
      if (typeof callback === 'function') callback(false);
      if (!response || response.status === 0 || response.status === 429 || response.status >= 500) {
        scheduleAccountRetry();
      }
    });
  }

  function notifyMutationCallback(requestId, ok, result) {
    var callback = pendingMutationCallbacks[requestId];
    if (!callback) return;
    delete pendingMutationCallbacks[requestId];
    callback(ok, result || null);
  }

  function responseErrorCode(response) {
    var error = response && response.data && response.data.error;
    return error && typeof error.code === 'string' ? error.code : null;
  }

  function finishAccountOperation(requestId) {
    if (saveAccountOutbox({ acknowledgeRequestId: requestId })) return true;
    removeAccountOperationLocally(requestId);
    accountOutboxPersistencePending = true;
    scheduleAccountRetry();
    return false;
  }

  function mutationSucceeded(operation, envelope) {
    accountSnapshot = envelope.wishlist;
    accountSnapshot.etag = envelope.etag;
    accountHasSnapshot = true;
    accountLoadedFromServer = true;
    saveAccountSnapshot();
    var outboxSaved = finishAccountOperation(operation.requestId);
    accountState = outboxSaved ? 'ready' : 'stale';

    var guestCleared = false;
    if (operation.operation === 'merge' && operation.importFingerprint) {
      guestCleared = clearGuestAfterImport(operation.importFingerprint);
    }

    updateAccountPresentation('account-' + operation.operation);
    notifyMutationCallback(operation.requestId, true, { guestCleared: guestCleared });
    accountMutationActive = false;
    flushAccountOutbox();
  }

  function handleMutationConflict(operation) {
    operation.conflictRetries += 1;
    if (operation.conflictRetries > ACCOUNT_MAX_CONFLICT_RETRIES) {
      finishAccountOperation(operation.requestId);
      accountState = 'stale';
      accountMutationActive = false;
      accountLoadedFromServer = false;
      updateAccountPresentation('conflict');
      notifyMutationCallback(operation.requestId, false, null);
      refreshAccount();
      return;
    }

    // The server can have committed before returning a concurrency error.
    // Keep the complete idempotency body immutable and reconcile with GET
    // before replaying the exact same requestId/body.
    if (!saveAccountOutbox()) {
      accountOutboxPersistencePending = true;
      accountState = 'stale';
      scheduleAccountRetry();
    }
    accountMutationActive = false;
    accountLoadedFromServer = false;
    refreshAccount();
  }

  function handleAccountChanged(operation) {
    accountMutationActive = false;
    accountLoadedFromServer = false;
    accountHasSnapshot = false;
    accountSnapshot = null;
    items = [];
    accountState = 'auth';
    updateAccountPresentation('account-changed');
    notifyMutationCallback(operation.requestId, false, null);
    // Preserve the old account outbox. A signed GET either confirms the same
    // opaque scope or activates the existing fail-closed account mismatch gate.
    refreshAccount();
  }

  function handleFatalAccountConflict(operation, source, hideSnapshot) {
    accountMutationActive = false;
    accountLoadedFromServer = false;
    accountStorageBlocked = true;
    if (hideSnapshot) {
      accountHasSnapshot = false;
      accountSnapshot = null;
      items = [];
    }
    accountState = 'unavailable';
    updateAccountPresentation(source);
    notifyMutationCallback(operation.requestId, false, null);
  }

  function rejectAccountOperation(operation, source) {
    accountMutationActive = false;
    accountLoadedFromServer = false;
    finishAccountOperation(operation.requestId);
    accountState = 'stale';
    updateAccountPresentation(source);
    notifyMutationCallback(operation.requestId, false, null);
    refreshAccount();
  }

  function flushAccountOutbox() {
    if (!accountMode || accountMutationActive || !accountLoadedFromServer
      || !accountHasSnapshot || !accountOutbox.length || accountStorageBlocked
      || accountOutboxPersistencePending) return;

    var operation = accountOutbox[0];
    if (operation.expectedAccountKey !== accountOpaqueKey) {
      handleFatalAccountConflict(operation, 'account-operation-scope-mismatch', true);
      return;
    }
    if (!operation.sent) {
      operation.sent = true;
      if (!saveAccountOutbox()) {
        operation.sent = false;
        accountState = 'stale';
        updateAccountPresentation('outbox-save-error');
        scheduleAccountRetry();
        return;
      }
      operation = accountOutbox.filter(function (candidate) {
        return candidate.requestId === operation.requestId;
      })[0];
      if (!operation) return;
    }

    var body = operationBody(operation);
    if (!body) {
      handleFatalAccountConflict(operation, 'account-operation-scope-mismatch', true);
      return;
    }
    accountMutationActive = true;
    request('POST', ACCOUNT_MUTATE_PATH, body, function (response) {
      var envelope = response && response.status >= 200 && response.status < 300
        ? parseAccountEnvelope(response.data)
        : null;
      if (envelope) {
        if (activateAccountScope(envelope.accountKey)) {
          mutationSucceeded(operation, envelope);
        } else {
          handleFatalAccountConflict(operation, 'account-mismatch', true);
        }
        return;
      }

      if (response && response.status === 409) {
        var conflictCode = responseErrorCode(response);
        if (conflictCode === 'CONCURRENT_MODIFICATION') {
          handleMutationConflict(operation);
        } else if (conflictCode === 'ACCOUNT_CHANGED') {
          handleAccountChanged(operation);
        } else if (conflictCode === 'STORED_DATA_INVALID'
          || conflictCode === 'STORED_DATA_VERSION'
          || conflictCode === 'IDEMPOTENCY_MARKER_INVALID') {
          handleFatalAccountConflict(operation, 'server-data-invalid');
        } else {
          // Includes IDEMPOTENCY_CONFLICT and unknown 409 responses. Creating
          // a fresh request here could revive an operation the server rejected.
          rejectAccountOperation(operation, 'mutation-conflict-rejected');
        }
        return;
      }

      var terminalCode = responseErrorCode(response);
      if (response && response.status === 410
        && (terminalCode === 'ACCOUNT_REDACTED' || terminalCode === 'SHOP_REDACTED')) {
        handleFatalAccountConflict(operation, 'account-redacted', true);
        return;
      }

      accountMutationActive = false;
      var authenticationError = response && (response.status === 401 || response.status === 403);
      accountLoadedFromServer = authenticationError ? false : accountLoadedFromServer;
      accountState = authenticationError ? 'auth' : 'stale';
      if (response && response.status >= 400 && response.status < 500
        && response.status !== 401 && response.status !== 403 && response.status !== 429) {
        var outboxSaved = finishAccountOperation(operation.requestId);
        accountState = outboxSaved ? 'ready' : 'stale';
        notifyMutationCallback(operation.requestId, false, null);
        updateAccountPresentation('mutation-rejected');
        flushAccountOutbox();
        return;
      }
      updateAccountPresentation('mutation-error');
      if (!response || response.status === 0 || response.status === 429
        || response.status >= 500 || response.status < 400) {
        scheduleAccountRetry();
      }
    });
  }

  function queueAccountMutation(operationName, value, callback) {
    if (!accountMode || accountStorageBlocked || !accountHasSnapshot) {
      return { ok: false, changed: false, pending: false, items: items.slice() };
    }

    var operationCreatedAt = now();
    var operation = {
      requestId: createRequestId(),
      expectedAccountKey: accountOpaqueKey,
      operation: operationName,
      baseRevision: accountSnapshot.revision,
      sent: false,
      conflictRetries: 0,
      order: nextAccountOperationOrder(operationCreatedAt),
      blocked: false,
      createdAt: operationCreatedAt,
      importFingerprint: null
    };
    if (operationName === 'merge') {
      if (accountImportIsPending()) {
        return { ok: true, changed: false, pending: true, items: items.slice() };
      }
      operation.handles = normalizeItems(value);
      operation.importFingerprint = getGuestFingerprint();
      if (!operation.handles.length || guestRecoveryBlocked || wasGuestListImported()) {
        return { ok: false, changed: false, pending: false, items: items.slice() };
      }
    } else {
      operation.handle = normalizeHandle(value);
      if (!operation.handle) {
        return { ok: false, changed: false, pending: false, items: items.slice() };
      }
    }

    var projected = applyAccountOperation(items, operation);
    var changed = !sameItems(projected, items);
    if (!changed) {
      return { ok: true, changed: false, pending: false, items: items.slice() };
    }

    var previousOutbox = accountOutbox.slice();
    var previousAcknowledgements = accountAcknowledgements.slice();
    accountOutbox.push(operation);
    // Queue success depends only on this request's independently verified key.
    // No shared read-modify-write can make another tab's operation disappear.
    if (!persistAccountOperation(operation)) {
      accountOutbox = previousOutbox;
      accountAcknowledgements = previousAcknowledgements;
      accountState = accountHasSnapshot ? 'stale' : 'unavailable';
      updateAccountPresentation('outbox-save-error');
      if (typeof callback === 'function') callback(false, null);
      return { ok: false, changed: false, pending: false, items: items.slice() };
    }
    if (typeof callback === 'function') pendingMutationCallbacks[operation.requestId] = callback;
    updateAccountPresentation('queued-' + operationName);
    flushAccountOutbox();
    return { ok: true, changed: true, pending: true, items: items.slice() };
  }

  function createPayload(values, updatedAt) {
    return {
      version: STORAGE_VERSION,
      items: normalizeItems(values),
      updatedAt: typeof updatedAt === 'number' ? updatedAt : now()
    };
  }

  function parsePayload(rawValue) {
    if (typeof rawValue !== 'string' || !rawValue) return null;

    try {
      var parsed = JSON.parse(rawValue);
      if (!parsed || parsed.version !== STORAGE_VERSION || !Array.isArray(parsed.items)) return null;

      var normalized = normalizeItems(parsed.items);
      if (normalized.length !== parsed.items.length) return null;

      return {
        version: STORAGE_VERSION,
        items: normalized,
        updatedAt: typeof parsed.updatedAt === 'number' ? parsed.updatedAt : 0
      };
    } catch (error) {
      return null;
    }
  }

  function readStorage(key) {
    if (!storage) return { status: 'unavailable', payload: null };

    try {
      var rawValue = storage.getItem(key);
      storageReadable = true;
      if (rawValue === null) return { status: 'absent', payload: null };

      var payload = parsePayload(rawValue);
      return payload
        ? { status: 'valid', payload: payload }
        : { status: 'invalid', payload: null };
    } catch (error) {
      storageReadable = false;
      return { status: 'unavailable', payload: null };
    }
  }

  function restorePrimary(payload) {
    if (!storage || !payload) return false;

    try {
      var rawValue = JSON.stringify(payload);
      storage.setItem(STORAGE_KEY, rawValue);
      var verified = parsePayload(storage.getItem(STORAGE_KEY));
      return !!verified && sameItems(verified.items, payload.items);
    } catch (error) {
      return false;
    }
  }

  function writeStorage(values, updatedAt) {
    if (!storage || !storageReadable) return false;

    var rawValue = JSON.stringify(createPayload(values, updatedAt));
    var previousPrimary;
    var previousBackup;
    var primarySnapshotTaken = false;
    var backupSnapshotTaken = false;

    try {
      previousPrimary = storage.getItem(STORAGE_KEY);
      primarySnapshotTaken = true;
      previousBackup = storage.getItem(BACKUP_KEY);
      backupSnapshotTaken = true;

      // Write and verify the backup first so a failed backup never follows a
      // successful primary write with stale recovery data.
      storage.setItem(BACKUP_KEY, rawValue);
      if (storage.getItem(BACKUP_KEY) !== rawValue) throw new Error('Wishlist backup verification failed');

      storage.setItem(STORAGE_KEY, rawValue);
      if (storage.getItem(STORAGE_KEY) !== rawValue) throw new Error('Wishlist primary verification failed');

      return true;
    } catch (error) {
      try {
        if (primarySnapshotTaken) {
          if (previousPrimary === null || typeof previousPrimary === 'undefined') {
            storage.removeItem(STORAGE_KEY);
          } else {
            storage.setItem(STORAGE_KEY, previousPrimary);
          }
        }
        if (backupSnapshotTaken) {
          if (previousBackup === null || typeof previousBackup === 'undefined') {
            storage.removeItem(BACKUP_KEY);
          } else {
            storage.setItem(BACKUP_KEY, previousBackup);
          }
        }
      } catch (rollbackError) {
        // The operation still fails visibly; a later load will use the last
        // independently verified primary/backup/cookie copy.
      }
      return false;
    }
  }

  function writeLegacyCookie(values) {
    var serialized = serializeLegacyCookie(values);

    try {
      if (!serialized) {
        if (!cookie.remove(COOKIE_NAME)) return false;
        var removedValue = safeCookieGet(COOKIE_NAME);
        return removedValue === null || removedValue === '';
      }
      if (serialized.length > MAX_COOKIE_VALUE_LENGTH) {
        // Avoid leaving a stale partial fallback once localStorage is authoritative.
        if (storageAuthority && storageReadable) cookie.remove(COOKIE_NAME);
        return false;
      }
      if (!cookie.set(COOKIE_NAME, serialized, COOKIE_DAYS)) return false;

      return sameItems(parseLegacyCookie(safeCookieGet(COOKIE_NAME)), normalizeItems(values));
    } catch (error) {
      return false;
    }
  }

  function restoreCookieValue(name, previousValue) {
    try {
      if (previousValue === null || typeof previousValue === 'undefined' || previousValue === '') {
        if (!cookie.remove(name)) return false;
        var removedValue = safeCookieGet(name);
        return removedValue === null || removedValue === '';
      }

      return cookie.set(name, previousValue, COOKIE_DAYS)
        && safeCookieGet(name) === previousValue;
    } catch (error) {
      return false;
    }
  }

  function writeCookieMirror(values, updatedAt) {
    var serialized = serializeLegacyCookie(values);
    var timestamp = typeof updatedAt === 'number' ? updatedAt : nextTimestamp();
    var marker = String(timestamp) + '|' + fingerprint(serialized);
    var previousLegacy = safeCookieGet(COOKIE_NAME);
    var previousMirror = safeCookieGet(MIRROR_COOKIE_NAME);

    try {
      // Commit the revision marker first. If the functional legacy cookie then
      // fails, the old legacy value still wins during reconciliation and the
      // marker is rolled back. This prevents a failed removal from disappearing
      // after reload.
      if (!cookie.set(MIRROR_COOKIE_NAME, marker, COOKIE_DAYS)
        || safeCookieGet(MIRROR_COOKIE_NAME) !== marker) {
        var failedMarkerRollback = restoreCookieValue(MIRROR_COOKIE_NAME, previousMirror);
        if (!failedMarkerRollback && !storageAuthority) recoveryBlocked = true;
        return false;
      }

      if (serialized.length > MAX_COOKIE_VALUE_LENGTH) {
        if (!storageAuthority || !storageReadable) {
          restoreCookieValue(MIRROR_COOKIE_NAME, previousMirror);
          return false;
        }

        // The complete list remains in verified localStorage. Keep only the
        // short revision fingerprint in cookies to avoid oversized headers.
        if (cookie.remove(COOKIE_NAME)) {
          var oversizedLegacy = safeCookieGet(COOKIE_NAME);
          if (oversizedLegacy === null || oversizedLegacy === '') return true;
        }

        restoreCookieValue(COOKIE_NAME, previousLegacy);
        restoreCookieValue(MIRROR_COOKIE_NAME, previousMirror);
        return false;
      }

      if (writeLegacyCookie(values)) return true;

      var legacyRestored = restoreCookieValue(COOKIE_NAME, previousLegacy);
      var mirrorRestored = restoreCookieValue(MIRROR_COOKIE_NAME, previousMirror);
      if ((!legacyRestored || !mirrorRestored) && !storageAuthority) recoveryBlocked = true;
      return false;
    } catch (error) {
      var legacyRollback = restoreCookieValue(COOKIE_NAME, previousLegacy);
      var mirrorRollback = restoreCookieValue(MIRROR_COOKIE_NAME, previousMirror);
      if ((!legacyRollback || !mirrorRollback) && !storageAuthority) recoveryBlocked = true;
      return false;
    }
  }

  function readMirrorCookie() {
    var rawValue = safeCookieGet(MIRROR_COOKIE_NAME);
    if (typeof rawValue !== 'string') return null;

    var separatorIndex = rawValue.indexOf('|');
    if (separatorIndex <= 0) return null;

    var timestamp = Number(rawValue.slice(0, separatorIndex));
    var storedFingerprint = rawValue.slice(separatorIndex + 1);
    if (typeof timestamp !== 'number' || !isFinite(timestamp)) return null;
    if (!/^[a-z0-9]+:\d+$/.test(storedFingerprint)) return null;

    return { timestamp: timestamp, fingerprint: storedFingerprint };
  }

  function safeCookieGet(name) {
    try {
      return cookie.get(name);
    } catch (error) {
      return null;
    }
  }

  function nextTimestamp(referenceTimestamp) {
    var reference = typeof referenceTimestamp === 'number' ? referenceTimestamp : currentUpdatedAt;
    return Math.max(now(), currentUpdatedAt + 1, reference + 1);
  }

  function readCookieRecoveryCandidate(referenceUpdatedAt, referenceItems) {
    var mirror = readMirrorCookie();
    if (!mirror) return null;

    var rawCookie = safeCookieGet(COOKIE_NAME);
    var cookieItems = readValidCookieItems();
    var currentSerialized = cookieItems === null ? null : serializeLegacyCookie(cookieItems);
    var currentFingerprint = currentSerialized === null ? null : fingerprint(currentSerialized);
    var emptyFingerprint = fingerprint('');

    // A legacy theme changed wishlistList without updating our marker.
    if (rawCookie !== null && cookieItems !== null && currentFingerprint !== mirror.fingerprint) {
      var referenceSerialized = Array.isArray(referenceItems)
        ? serializeLegacyCookie(referenceItems)
        : '';
      var referenceWasTooLargeForCookie = referenceSerialized.length > MAX_COOKIE_VALUE_LENGTH
        && mirror.fingerprint === fingerprint(referenceSerialized);

      return {
        // A rolled-back legacy theme cannot see an oversized localStorage list
        // because its compatibility cookie is intentionally absent. Preserve
        // those hidden items and merge any additions made during the rollback.
        items: referenceWasTooLargeForCookie
          ? normalizeItems(referenceItems.concat(cookieItems))
          : cookieItems,
        timestamp: nextTimestamp(Math.max(referenceUpdatedAt, mirror.timestamp))
      };
    }

    // A cookie-only fallback from a temporarily blocked localStorage is newer.
    // An empty list is represented by a newer marker plus an absent legacy cookie.
    var markerMatchesCookie = currentFingerprint === mirror.fingerprint
      || (legacyCookieReadable && mirror.fingerprint === emptyFingerprint && rawCookie === null);
    if (markerMatchesCookie && mirror.timestamp > referenceUpdatedAt) {
      return {
        items: cookieItems === null ? [] : cookieItems.slice(),
        timestamp: mirror.timestamp
      };
    }

    return null;
  }

  function load() {
    recoveryBlocked = false;
    var primary = readStorage(STORAGE_KEY);
    storageAuthority = primary.status !== 'unavailable';
    var cookieItems = readValidCookieItems();

    if (primary.status === 'valid') {
      items = primary.payload.items.slice();
      currentUpdatedAt = primary.payload.updatedAt;
      var primaryCookieCandidate = readCookieRecoveryCandidate(currentUpdatedAt, items);

      if (primaryCookieCandidate) {
        items = primaryCookieCandidate.items.slice();
        if (writeStorage(items, primaryCookieCandidate.timestamp)) {
          currentUpdatedAt = primaryCookieCandidate.timestamp;
          writeCookieMirror(items, currentUpdatedAt);
          return items.slice();
        }

        // Keep the recoverable cookie visible, but refuse mutations until a
        // reload can persist it transactionally.
        recoveryBlocked = true;
        return items.slice();
      }

      var currentBackup = readStorage(BACKUP_KEY);
      if (currentBackup.status !== 'valid' || !sameItems(currentBackup.payload.items, items)) {
        writeStorage(items, currentUpdatedAt);
      }
      writeCookieMirror(items, currentUpdatedAt);
      return items.slice();
    }

    var corruptStorageFound = primary.status === 'invalid';
    if (primary.status === 'invalid' || primary.status === 'absent') {
      var backup = readStorage(BACKUP_KEY);
      if (backup.status === 'valid') {
        items = backup.payload.items.slice();
        currentUpdatedAt = backup.payload.updatedAt;
        var backupCookieCandidate = readCookieRecoveryCandidate(currentUpdatedAt, items);
        if (backupCookieCandidate) {
          items = backupCookieCandidate.items.slice();
          if (!writeStorage(items, backupCookieCandidate.timestamp)) {
            recoveryBlocked = true;
            return items.slice();
          }
          currentUpdatedAt = backupCookieCandidate.timestamp;
          writeCookieMirror(items, currentUpdatedAt);
          return items.slice();
        }

        restorePrimary(backup.payload);
        writeCookieMirror(items, currentUpdatedAt);
        return items.slice();
      }
      if (backup.status === 'invalid') corruptStorageFound = true;
    }

    var standaloneCookieCandidate = readCookieRecoveryCandidate(0);
    if (cookieItems === null && standaloneCookieCandidate) {
      cookieItems = standaloneCookieCandidate.items.slice();
      currentUpdatedAt = standaloneCookieCandidate.timestamp;
    }

    if (corruptStorageFound && cookieItems === null) {
      // Preserve unknown/future/corrupt bytes for manual recovery. Never turn
      // uncertain data into a verified empty list.
      recoveryBlocked = true;
      items = [];
      return items.slice();
    }

    if (cookieItems === null) {
      var orphanedMirror = readMirrorCookie();
      if (!legacyCookieReadable
        || (orphanedMirror && orphanedMirror.fingerprint !== fingerprint(''))) {
        // A non-empty fingerprint proves data existed even though no complete
        // copy is currently readable. Preserve the clue and never overwrite it
        // with a fabricated empty list.
        recoveryBlocked = true;
        items = [];
        return items.slice();
      }
    }

    var migratedItems = cookieItems === null ? [] : cookieItems;
    items = migratedItems.slice();

    if (storageAuthority && storageReadable) {
      var migrationTimestamp = nextTimestamp(0);
      if (writeStorage(items, migrationTimestamp)) {
        currentUpdatedAt = migrationTimestamp;
        writeCookieMirror(items, currentUpdatedAt);
      }
    } else {
      var existingMirror = readMirrorCookie();
      var emptyFingerprint = fingerprint('');

      if (cookieItems === null) {
        if (!legacyCookieReadable) {
          recoveryBlocked = true;
        } else if (existingMirror && existingMirror.fingerprint !== emptyFingerprint) {
          // A marker proves that a non-empty cookie copy existed, but the list
          // itself cannot be reconstructed while localStorage is unavailable.
          recoveryBlocked = true;
        }
      }

      // Refresh only a readable, reconstructable legacy copy. Do not advance
      // the revision while the authoritative localStorage may be hidden.
      if (!recoveryBlocked) writeLegacyCookie(items);
      if (existingMirror) currentUpdatedAt = existingMirror.timestamp;
    }

    return items.slice();
  }

  function readValidCookieItems() {
    var rawValue;
    try {
      rawValue = cookie.get(COOKIE_NAME);
      legacyCookieReadable = true;
    } catch (error) {
      legacyCookieReadable = false;
      return null;
    }
    if (rawValue === null || typeof rawValue === 'undefined') return null;
    if (rawValue === '' || rawValue === '__') return [];

    var parsed = parseLegacyCookie(rawValue);
    return parsed.length ? parsed : null;
  }

  function reconcileBeforeMutation() {
    if (recoveryBlocked) return false;

    if (!storageAuthority) {
      var fallbackItems = readValidCookieItems();
      if (fallbackItems === null) {
        var fallbackMirror = readMirrorCookie();
        if (fallbackMirror && fallbackMirror.fingerprint === fingerprint('')) {
          fallbackItems = [];
          currentUpdatedAt = fallbackMirror.timestamp;
        } else if (legacyCookieReadable && !fallbackMirror) {
          fallbackItems = [];
        } else {
          return false;
        }
      }
      items = fallbackItems.slice();
      return true;
    }

    var primary = readStorage(STORAGE_KEY);
    if (primary.status === 'unavailable') return false;

    if (primary.status === 'valid') {
      items = primary.payload.items.slice();
      currentUpdatedAt = primary.payload.updatedAt;
      var primaryCookieCandidate = readCookieRecoveryCandidate(currentUpdatedAt, items);
      if (primaryCookieCandidate) {
        if (!writeStorage(primaryCookieCandidate.items, primaryCookieCandidate.timestamp)) return false;
        items = primaryCookieCandidate.items.slice();
        currentUpdatedAt = primaryCookieCandidate.timestamp;
        writeCookieMirror(items, currentUpdatedAt);
      }
      return true;
    }

    if (primary.status === 'invalid' || primary.status === 'absent') {
      var backup = readStorage(BACKUP_KEY);
      if (backup.status === 'valid') {
        items = backup.payload.items.slice();
        currentUpdatedAt = backup.payload.updatedAt;
        var backupCookieCandidate = readCookieRecoveryCandidate(currentUpdatedAt, items);
        if (backupCookieCandidate) {
          if (!writeStorage(backupCookieCandidate.items, backupCookieCandidate.timestamp)) return false;
          items = backupCookieCandidate.items.slice();
          currentUpdatedAt = backupCookieCandidate.timestamp;
          writeCookieMirror(items, currentUpdatedAt);
        } else if (!restorePrimary(backup.payload)) {
          return false;
        }
        return true;
      }
    }

    var cookieItems = readValidCookieItems();
    if (cookieItems !== null) {
      items = cookieItems;
      var recoveryTimestamp = nextTimestamp();
      if (!writeStorage(items, recoveryTimestamp)) return false;
      currentUpdatedAt = recoveryTimestamp;
      writeCookieMirror(items, currentUpdatedAt);
      return true;
    }

    return false;
  }

  function persist(nextItems) {
    var normalized = normalizeItems(nextItems);
    var persistenceTimestamp = nextTimestamp();

    if (storageAuthority) {
      if (!writeStorage(normalized, persistenceTimestamp)) return false;
      currentUpdatedAt = persistenceTimestamp;
      writeCookieMirror(normalized, currentUpdatedAt);
      return true;
    }

    if (!writeCookieMirror(normalized, persistenceTimestamp)) return false;
    currentUpdatedAt = persistenceTimestamp;
    return true;
  }

  function emitChange(source) {
    if (!doc || typeof doc.dispatchEvent !== 'function') return;

    var detail = { items: items.slice(), source: source };
    var event;

    try {
      event = new CustomEvent('vmax:wishlist:change', { detail: detail });
    } catch (error) {
      if (!doc.createEvent) return;
      event = doc.createEvent('CustomEvent');
      event.initCustomEvent('vmax:wishlist:change', false, false, detail);
    }

    doc.dispatchEvent(event);
  }

  function commit(nextItems, source) {
    var normalized = normalizeItems(nextItems);
    if (!persist(normalized)) {
      return { ok: false, changed: false, items: items.slice() };
    }

    var changed = !sameItems(items, normalized);
    items = normalized;
    syncButtons();
    if (changed) {
      renderWishlistPage();
      emitChange(source);
    }

    return { ok: true, changed: changed, items: items.slice() };
  }

  function add(handleValue, callback) {
    if (accountMode) return queueAccountMutation('add', handleValue, callback);

    var handle = normalizeHandle(handleValue);
    if (!handle) return { ok: false, changed: false, items: items.slice() };

    if (!reconcileBeforeMutation()) {
      return { ok: false, changed: false, items: items.slice() };
    }

    if (items.indexOf(handle) !== -1) {
      syncButtons();
      return { ok: true, changed: false, items: items.slice() };
    }

    return commit(items.concat([handle]), 'add');
  }

  function remove(handleValue, callback) {
    if (accountMode) return queueAccountMutation('remove', handleValue, callback);

    var handle = normalizeHandle(handleValue);
    if (!handle) return { ok: false, changed: false, items: items.slice() };

    if (!reconcileBeforeMutation()) {
      return { ok: false, changed: false, items: items.slice() };
    }

    var nextItems = items.filter(function (item) { return item !== handle; });
    if (nextItems.length === items.length) {
      return { ok: true, changed: false, items: items.slice() };
    }

    return commit(nextItems, 'remove');
  }

  function getHandleSelector(prefix, handle) {
    return '.' + prefix + handle;
  }

  function setDisplay(selector, displayValue) {
    if (!doc || typeof doc.querySelectorAll !== 'function') return;

    var elements = doc.querySelectorAll(selector);
    for (var index = 0; index < elements.length; index += 1) {
      elements[index].style.display = displayValue;
    }
  }

  function accountHandleIsPending(handle) {
    for (var index = 0; index < accountOutbox.length; index += 1) {
      var operation = accountOutbox[index];
      if (operation.handle === handle
        || (operation.handles && operation.handles.indexOf(handle) !== -1)) return true;
    }
    return false;
  }

  function accountImportIsPending() {
    for (var index = 0; index < accountOutbox.length; index += 1) {
      if (accountOutbox[index].operation === 'merge') return true;
    }
    return false;
  }

  function syncButtons() {
    if (!doc || typeof doc.querySelectorAll !== 'function') return;

    var buttons = doc.querySelectorAll('.add-in-wishlist-js[data-href]');
    for (var index = 0; index < buttons.length; index += 1) {
      var handle = normalizeHandle(buttons[index].getAttribute('data-href'));
      if (!handle) continue;

      var unavailable = accountMode && !accountHasSnapshot;
      var pending = accountMode && accountHandleIsPending(handle);
      var isAdded = items.indexOf(handle) !== -1;
      setDisplay(getHandleSelector('default-wishbutton-', handle), unavailable || pending || isAdded ? 'none' : '');
      setDisplay(getHandleSelector('loadding-wishbutton-', handle), unavailable || pending ? 'block' : 'none');
      setDisplay(getHandleSelector('added-wishbutton-', handle), !unavailable && !pending && isAdded ? 'block' : 'none');
      if (unavailable) {
        buttons[index].setAttribute('aria-disabled', 'true');
      } else {
        buttons[index].removeAttribute('aria-disabled');
      }
      if (pending) {
        buttons[index].setAttribute('aria-busy', 'true');
      } else {
        buttons[index].removeAttribute('aria-busy');
      }
    }
  }

  function closestAddButton(target) {
    if (!target) return null;
    if (typeof target.closest === 'function') return target.closest('.add-in-wishlist-js');

    var node = target;
    while (node && node !== doc) {
      if (node.classList && node.classList.contains('add-in-wishlist-js')) return node;
      node = node.parentNode;
    }

    return null;
  }

  function getMessage(selector, fallback) {
    if (!doc || typeof doc.querySelector !== 'function') return fallback;
    var element = doc.querySelector(selector);
    return element && element.textContent.trim() ? element.textContent.trim() : fallback;
  }

  function notify(type, message) {
    if (win && win.jQuery && typeof win.jQuery.notify === 'function') {
      win.jQuery.notify(
        { message: message },
        {
          type: type,
          offset: 0,
          placement: { from: 'top', align: 'center' },
          z_index: 9999
        }
      );
      return;
    }

    if (type === 'danger' && win && typeof win.alert === 'function') {
      win.alert(message);
    }
  }

  function onDocumentClick(event) {
    var button = closestAddButton(event.target);
    if (!button) return;

    event.preventDefault();
    var result = add(button.getAttribute('data-href'), function (ok) {
      if (ok) {
        notify('success', getMessage(
          '#wishlistmessage .title-success',
          (strings.added || '')
        ));
      } else {
        notify('danger', getMessage(
          '#wishlistmessage .title-failed',
          (strings.sync_error || '')
        ));
      }
    });

    if (!result.ok) {
      notify('danger', getMessage(
        '#wishlistmessage .title-failed',
        (strings.save_error || '')
      ));
      return;
    }

    if (result.pending) return;

    if (result.changed) {
      notify('success', getMessage(
        '#wishlistmessage .title-success',
        (strings.added || '')
      ));
    }
  }

  function onStorage(event) {
    if (accountMode) {
      var accountStorageKey = event && event.key;
      var accountJournalEvent = typeof accountStorageKey === 'string'
        && typeof accountOperationPrefix === 'string'
        && typeof accountAcknowledgementPrefix === 'string'
        && (accountStorageKey.indexOf(accountOperationPrefix) === 0
          || accountStorageKey.indexOf(accountAcknowledgementPrefix) === 0);
      if (!event || (accountStorageKey !== accountCacheKey
        && accountStorageKey !== accountOutboxKey
        && !accountJournalEvent
        && accountStorageKey !== null)) return;
      accountLoadedFromServer = false;
      loadAccountState();
      updateAccountPresentation('account-storage');
      refreshAccount();
      return;
    }

    if (!event || (event.key !== STORAGE_KEY && event.key !== null)) return;
    if (!storageAuthority) return;

    var primary = readStorage(STORAGE_KEY);
    if (primary.status === 'unavailable') return;

    var nextItems = null;
    var nextUpdatedAt = 0;
    var wasRecoveryBlocked = recoveryBlocked;
    if (primary.status === 'valid') {
      nextItems = primary.payload.items;
      nextUpdatedAt = primary.payload.updatedAt;
    } else {
      var backup = readStorage(BACKUP_KEY);
      if (backup.status === 'valid') {
        nextItems = backup.payload.items;
        nextUpdatedAt = backup.payload.updatedAt;
        restorePrimary(backup.payload);
      } else {
        nextItems = readValidCookieItems();
        if (nextItems !== null) {
          nextUpdatedAt = nextTimestamp();
          if (!writeStorage(nextItems, nextUpdatedAt)) return;
        }
      }
    }

    // Never turn uncertain storage corruption into an empty list.
    if (nextItems === null) return;

    var cookieCandidate = readCookieRecoveryCandidate(nextUpdatedAt, nextItems);
    if (cookieCandidate) {
      if (!writeStorage(cookieCandidate.items, cookieCandidate.timestamp)) return;
      nextItems = cookieCandidate.items.slice();
      nextUpdatedAt = cookieCandidate.timestamp;
    }

    recoveryBlocked = false;
    currentUpdatedAt = nextUpdatedAt;
    if (sameItems(items, nextItems)) {
      writeCookieMirror(items, currentUpdatedAt);
      if (wasRecoveryBlocked) renderWishlistPage();
      return;
    }

    items = nextItems.slice();
    writeCookieMirror(items, currentUpdatedAt);
    syncButtons();
    renderWishlistPage();
    emitChange('storage');
  }

  function clearElement(element) {
    while (element && element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function appendTextElement(parent, tagName, className, text) {
    var element = doc.createElement(tagName);
    if (className) element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function createLink(href, className, text) {
    var link = doc.createElement('a');
    link.href = href;
    if (className) link.className = className;
    if (text) link.textContent = text;
    return link;
  }

  function createRemoveCell(handle, label) {
    var cell = doc.createElement('td');
    cell.className = 'product-remove';

    var button = doc.createElement('button');
    button.type = 'button';
    button.className = 'remove remove_from_wishlist product-remove-js';
    button.setAttribute('data-vmax-wishlist-remove', handle);
    button.setAttribute('aria-label', label);
    button.title = label;
    button.textContent = '\u00d7';
    button.style.background = 'none';
    button.style.border = '0';
    button.style.color = 'inherit';
    button.style.cursor = 'pointer';
    button.style.padding = '0';
    cell.appendChild(button);

    return cell;
  }

  function createProductRow(handle, product, labels, isLoading) {
    var row = doc.createElement('tr');
    row.setAttribute('data-vmax-wishlist-handle', handle);
    row.appendChild(createRemoveCell(handle, labels.remove));

    var thumbnailCell = doc.createElement('td');
    thumbnailCell.className = 'product-thumbnail';
    thumbnailCell.style.width = '100px';

    var productUrl = product && product.url ? product.url : (routes.productBaseUrl || '') + encodeURIComponent(handle);
    if (product && product.featured_image) {
      var imageLink = createLink(productUrl, 'wishlist-item-link');
      var image = doc.createElement('img');
      image.loading = 'lazy';
      image.className = 'img-responsive';
      image.src = product.featured_image;
      image.alt = product.title || handle;
      imageLink.appendChild(image);
      thumbnailCell.appendChild(imageLink);
    }
    row.appendChild(thumbnailCell);

    var nameCell = doc.createElement('td');
    nameCell.className = 'product-name';
    if (product) {
      nameCell.appendChild(createLink(productUrl, 'wishlist-item-link', product.title || handle));
    } else if (isLoading) {
      appendTextElement(nameCell, 'span', 'wishlist-item-loading', handle + ' \u2014 ' + labels.loading);
    } else {
      appendTextElement(nameCell, 'span', 'wishlist-item-unavailable', handle + ' \u2014 ' + labels.unavailable);
    }
    row.appendChild(nameCell);

    var priceCell = doc.createElement('td');
    priceCell.className = 'wishlist-product-price product-price';
    var availableVariant = null;
    if (product && Array.isArray(product.variants)) {
      for (var variantIndex = 0; variantIndex < product.variants.length; variantIndex += 1) {
        if (product.variants[variantIndex].available === true) {
          availableVariant = product.variants[variantIndex];
          break;
        }
      }
    }

    if (isLoading) {
      priceCell.textContent = labels.loading;
    } else if (availableVariant && shopify && typeof shopify.formatMoney === 'function') {
      appendTextElement(priceCell, 'span', 'money', shopify.formatMoney(availableVariant.price));
    } else {
      priceCell.textContent = product ? labels.soldOut : labels.unavailable;
    }
    row.appendChild(priceCell);

    var actionCell = doc.createElement('td');
    actionCell.className = 'product-add-to-cart';
    if (product) {
      var viewLink = createLink(productUrl, 'button wishlist-item-link btn', labels.viewProduct);
      viewLink.rel = 'nofollow';
      actionCell.appendChild(viewLink);
    } else if (isLoading) {
      actionCell.textContent = labels.loading;
    } else {
      actionCell.textContent = labels.unavailable;
    }
    row.appendChild(actionCell);

    return row;
  }

  function fetchProduct(handle, callback) {
    if (!shopify || typeof shopify.getProduct !== 'function') {
      callback(null);
      return;
    }

    var settled = false;
    var timer = setTimer(function () {
      if (!settled) {
        settled = true;
        callback(null);
      }
    }, PRODUCT_TIMEOUT_MS);

    try {
      shopify.getProduct(handle, function (product) {
        if (settled) return;
        settled = true;
        clearTimer(timer);
        callback(product && product.handle ? product : null);
      });
    } catch (error) {
      if (!settled) {
        settled = true;
        clearTimer(timer);
        callback(null);
      }
    }
  }

  function pumpProductRequestQueue() {
    while (activeProductRequests < MAX_CONCURRENT_PRODUCT_REQUESTS && productRequestQueue.length) {
      var request = productRequestQueue.shift();
      if (request.version !== pageRenderVersion) continue;

      activeProductRequests += 1;
      fetchProduct(request.handle, function (queuedRequest) {
        return function (product) {
          activeProductRequests -= 1;
          try {
            if (queuedRequest.version === pageRenderVersion) queuedRequest.callback(product);
          } finally {
            pumpProductRequestQueue();
          }
        };
      }(request));
    }
  }

  function queueProductRequest(handle, version, callback) {
    productRequestQueue.push({ handle: handle, version: version, callback: callback });
    pumpProductRequestQueue();
  }

  function getPageLabels(marker) {
    return {
      empty: marker.getAttribute('data-wishlist-empty') || (strings.empty || ''),
      recoveryFailed: marker.getAttribute('data-recovery-failed')
        || (strings.recoveryFailed || ''),
      syncing: marker.getAttribute('data-account-syncing') || (strings.syncing || ''),
      syncFailed: marker.getAttribute('data-account-sync-failed')
        || (strings.syncFailed || ''),
      authRequired: marker.getAttribute('data-account-auth-required')
        || (strings.authRequired || ''),
      changesPending: marker.getAttribute('data-account-changes-pending')
        || (strings.changesPending || ''),
      viewProduct: marker.getAttribute('data-view-product') || (strings.viewProduct || ''),
      soldOut: marker.getAttribute('data-sold-out') || (strings.soldOut || ''),
      unavailable: marker.getAttribute('data-unavailable') || (strings.unavailable || ''),
      loading: marker.getAttribute('data-loading') || (strings.loading || ''),
      remove: marker.getAttribute('data-remove') || (strings.remove || '')
    };
  }

  function updateAccountPageUi(marker, labels) {
    if (!accountMode || !marker || !marker.parentNode || !marker.parentNode.querySelector) return;

    var status = marker.parentNode.querySelector('[data-vmax-wishlist-status]');
    if (status) {
      var message = '';
      if (accountStorageBlocked) message = labels.recoveryFailed;
      else if (accountState === 'loading') message = labels.syncing;
      else if (accountState === 'auth') message = labels.authRequired;
      else if (accountState === 'stale' || accountState === 'unavailable') message = labels.syncFailed;
      else if (accountOutbox.length) message = labels.changesPending;

      status.textContent = message;
      status.hidden = !message;
    }

    var importPanel = marker.parentNode.querySelector('[data-vmax-wishlist-import]');
    if (importPanel) {
      var canImport = accountHasSnapshot && guestItems.length && !guestRecoveryBlocked
        && !accountStorageBlocked && !wasGuestListImported();
      importPanel.hidden = !canImport;
      var importButton = importPanel.querySelector('[data-vmax-wishlist-import-button]');
      if (importButton) {
        importButton.disabled = accountImportIsPending() || accountMutationActive
          || accountState === 'auth' || accountState === 'unavailable';
        importButton.setAttribute('aria-disabled', importButton.disabled ? 'true' : 'false');
      }
    }
  }

  function showEmptyWishlist(wrapper, table, message) {
    table.style.display = 'none';
    table.removeAttribute('aria-busy');
    var emptyMessage = wrapper.querySelector('.empty-wishlist');
    if (!emptyMessage) {
      emptyMessage = appendTextElement(wrapper, 'div', 'text-center alert alert-info empty-wishlist', message);
    } else {
      emptyMessage.textContent = message;
      emptyMessage.style.display = '';
    }
  }

  function hideWishlistTable(wrapper, table) {
    table.style.display = 'none';
    table.removeAttribute('aria-busy');
    var emptyMessage = wrapper.querySelector('.empty-wishlist');
    if (emptyMessage) emptyMessage.style.display = 'none';
  }

  function findWishlistRow(body, handle) {
    var rows = body.querySelectorAll('[data-vmax-wishlist-handle]');
    for (var index = 0; index < rows.length; index += 1) {
      if (rows[index].getAttribute('data-vmax-wishlist-handle') === handle) return rows[index];
    }
    return null;
  }

  function renderWishlistPage() {
    if (!doc || typeof doc.getElementById !== 'function') return;

    var marker = doc.getElementById('wishlist-js');
    if (!marker) return;

    var wrapper = marker.parentNode && marker.parentNode.querySelector
      ? marker.parentNode.querySelector('.table-wrapper')
      : doc.querySelector('.table-wrapper');
    var table = wrapper && wrapper.querySelector('.wishlist_table');
    var body = table && table.querySelector('.wishlist-box');
    if (!wrapper || !table || !body) return;

    var labels = getPageLabels(marker);
    var version = pageRenderVersion += 1;
    clearElement(body);
    updateAccountPageUi(marker, labels);

    if (accountMode && !accountHasSnapshot) {
      // The account status region already announces loading, authentication,
      // and synchronization failures. Keep the table hidden until a signed
      // server snapshot exists instead of announcing the same state twice.
      hideWishlistTable(wrapper, table);
      return;
    }

    if (!items.length) {
      var emptyMessageText = recoveryBlocked ? labels.recoveryFailed : labels.empty;
      showEmptyWishlist(wrapper, table, emptyMessageText);
      return;
    }

    var emptyMessage = wrapper.querySelector('.empty-wishlist');
    if (emptyMessage) emptyMessage.style.display = 'none';
    table.style.display = '';
    table.setAttribute('aria-busy', 'true');

    var handles = items.slice();
    var remaining = handles.length;

    handles.forEach(function (handle) {
      body.appendChild(createProductRow(handle, null, labels, true));

      queueProductRequest(handle, version, function (requestedHandle) {
        return function (product) {
          try {
            var currentRow = findWishlistRow(body, requestedHandle);
            if (currentRow) {
              try {
                body.replaceChild(createProductRow(requestedHandle, product, labels, false), currentRow);
              } catch (renderError) {
                body.replaceChild(createProductRow(requestedHandle, null, labels, false), currentRow);
              }
            }
          } finally {
            remaining -= 1;
            if (remaining === 0) table.removeAttribute('aria-busy');
          }
        };
      }(handle));
    });
  }

  function onWishlistPageClick(event) {
    var target = event.target;
    if (!target || !target.getAttribute) return;

    if (target.getAttribute('data-vmax-wishlist-import-button') !== null) {
      event.preventDefault();
      var importResult = queueAccountMutation('merge', guestItems, function (ok, result) {
        if (!ok) {
          notify('danger', getMessage(
            '#wishlistmessage .title-failed',
            (strings.sync_error || '')
          ));
        } else if (result && result.guestCleared === false) {
          notify('warning', target.getAttribute('data-local-copy-kept')
            || (strings.local_copy_kept || ''));
        } else {
          notify('success', target.getAttribute('data-import-success')
            || (strings.import_success || ''));
        }
      });
      if (!importResult.ok) {
        notify('danger', getMessage(
          '#wishlistmessage .title-failed',
          (strings.sync_error || '')
        ));
      }
      return;
    }

    var handle = target.getAttribute('data-vmax-wishlist-remove');
    if (!handle) return;

    event.preventDefault();
    var result = remove(handle, function (ok) {
      if (!ok) {
        notify('danger', getMessage(
          '#wishlistmessage .title-failed',
          (strings.sync_error || '')
        ));
      }
    });
    if (!result.ok) {
      notify('danger', getMessage(
        '#wishlistmessage .title-failed',
        (strings.save_error || '')
      ));
    }
  }

  function onAccountReconnect() {
    if (!accountMode) return;
    refreshAccount();
  }

  function initialize() {
    var firstInitialization = false;
    if (!initialized) {
      load();
      if (accountMode) {
        guestItems = items.slice();
        guestRecoveryBlocked = recoveryBlocked;
        items = [];
        recoveryBlocked = false;
      }
      initialized = true;
      firstInitialization = true;

      if (doc && typeof doc.addEventListener === 'function') {
        doc.addEventListener('click', onDocumentClick);
        doc.addEventListener('click', onWishlistPageClick);
      }
      if (eventTarget && typeof eventTarget.addEventListener === 'function') {
        eventTarget.addEventListener('storage', onStorage);
        if (accountMode) eventTarget.addEventListener('online', onAccountReconnect);
      }
    }

    if (win) win.setupWishlistButtons = syncButtons;
    syncButtons();
    if (firstInitialization) renderWishlistPage();
    if (firstInitialization && accountMode) refreshAccount();

    return api;
  }

  var api = {
    initialize: initialize,
    getItems: function () { return items.slice(); },
    isRecoveryBlocked: function () {
      return accountMode
        ? accountStorageBlocked || (!accountHasSnapshot && accountState !== 'loading')
        : recoveryBlocked;
    },
    has: function (handle) { return items.indexOf(normalizeHandle(handle)) !== -1; },
    add: add,
    remove: remove,
    importGuestWishlist: function (callback) {
      return queueAccountMutation('merge', guestItems, callback);
    },
    syncButtons: syncButtons,
    renderWishlistPage: renderWishlistPage,
    _constants: {
      cookieName: COOKIE_NAME,
      mirrorCookieName: MIRROR_COOKIE_NAME,
      storageKey: STORAGE_KEY,
      backupKey: BACKUP_KEY,
      storageVersion: STORAGE_VERSION,
      cookieDays: COOKIE_DAYS,
      accountProxyPath: ACCOUNT_PROXY_PATH,
      accountMutatePath: ACCOUNT_MUTATE_PATH,
      accountStoragePrefix: 'vmaxWishlist.account.',
      adapterVersion: '2.0.0'
    }
  };

  if (doc) {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', initialize, false);
    } else {
      initialize();
    }
  }

  return api;
}));
